<template>
  <div
    class="signIn_wrap"
    :style="{ backgroundImage: `url(${moduleIconUrl})` }"
    v-if="signInList.length>0"
  >
    <div class="header">
      <div class="header_info">
        <span
          class="header_title"
          :style="{
            textShadow: `0px 2px 8px ${buttonColor}`,
          }"
          >{{ componentConfig.title }}</span
        >
        <span
          class="header_desc"
          :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
          >{{ componentConfig.subtitle }}</span
        >
      </div>
      <div class="header_change">
        <div
          class="change_btn"
          @click="showMyPrizeEvent()"
          :style="{ background:buttonColor }"
        >
          我的奖品
        </div>
        <div
          class="change_btn rule_btn"
          @click="openRule()"
          :style="{ background: buttonColor }"
        >
          规则
        </div>
      </div>
    </div>

    <div class="content" v-if="loading">
      <div class="empty">
        <div class="skeleton"></div>
      </div>
    </div>
    <div class="content" v-else>
      <div class="sign_wrap">
        <div class="sign_tip" v-if="nextAwardDTO">再签到<span>{{nextAwardDTO.restDays}}</span>天，可获得<span>{{nextAwardDTO.prizeName}}</span>x{{nextAwardDTO.prizeCount}}</div>
        <div class="sign_tip" v-else>已经累计签到<span>{{totalSignInCount}}</span>天</div>
        <div class="sign_item">
          <div class="sign_box" v-for="item in signInShowList" :key="item.id">
            <div class="box_wrap" :class="item.signStatus==2&&'signed_box'" >
              <!-- 已签1 未签 -->
              <div class="prize" @click="awardInfo(item)">
                <!-- 空奖 -->
                <img v-if="item.awardDTO.prizeType==0" src="./images/empty_prize.png" alt="">
                <template v-else>
                  <!-- <img src="./images/prize.png" alt=""> -->
                  <img :src="item.awardDTO.prizeImgUrl" alt="">
                  <div class="count">x{{item.awardDTO.prizeCount}}</div>
                  <div class="without" v-if="item.awardDTO.status==4">缺货</div>
                </template>
              </div>
              <!-- //签到的状态,1-未签到 2-已签 3-明天再来 -->
              <div v-if="totalSignInCount+1==item.signIndex&&item.signStatus==1" class="sign_btn" @click="signInHandle(item)">签到</div>
              <div v-else-if="item.signStatus==1" class="days">第{{item.signIndex}}天</div>
              <img v-else-if="item.signStatus==3" class="next_day" src="./images/next_day.png" alt="">
              <div v-else-if="item.signStatus==2" class="signed">已签</div>
              <!-- <div v-else-if="i==2" class="signed">已获得</div> -->
            </div>
          </div>
        </div>
        <div class="all_btn" v-if="signInList.length>10" @click="openAll = !openAll">
          <template v-if="!openAll">
            查看全部
            <img class="arrow" src="./images/arrow_small_line.svg" alt="">
          </template>
          <template v-else>
            收起
            <img class="arrow close" src="./images/arrow_small_line.svg" alt="">
          </template>
        </div>
      </div>
    </div>
    <!-- <div class="prize_box" :id="`prize_box${componentConfig.id}`">
      <div>
        <img src="./images/left.png" alt="" />
        <img :src="currprize" alt="" />
        <img src="./images/right.png" alt="" />
      </div>
      <div class="prize_name">
        恭喜你获得{{ currprizeCount }}次<br />{{ currprizeText }}
      </div>
    </div> -->
    <van-action-sheet v-model="showRule" class="rule_van-popup">
      <div class="rule_wrap">
        <img
          @click="showRule = false"
          class="rule_close"
          src="./images/close.svg"
          alt=""
        />
        <div class="rule_content">
          <div class="text_bg">
            <div class="rule_text">
              {{componentConfig.rewardExplain}}
              <!-- <div v-for="i in 50" :key="i">
                {{i}}.文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本文本
              </div> -->
              <br>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
    <!-- 奖品弹窗 -->
    <win-prize-pop :prizeResult="prizeResult" ref="prizePop" :platform="platformRrize" @cancel="afterCloseAction" @submitWinInfo='submitWinInfo'></win-prize-pop>
    <!-- 我的奖品 -->
    <my-prize-list v-model="showPrizeList" :platform="platformRrize" @queryWinRecords='getWinAwardList' @submitWinInfo='submitWinInfo'/>
  </div>
</template>

<script>
import { ActionSheet } from "vant";
import WinPrizePop from './components/winPrizePop.vue';
// import MyPrizeList from './components/myPrizeList.vue';
import MyPrizeList from '@51job/jbs-bigcard-component/lib/MyPrizeList.js';
import { mapState } from "vuex";
export default {
  name: "SignInComponent",
  components: {
    MyPrizeList,
    WinPrizePop,
    [ActionSheet.name]: ActionSheet,
  },
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
    pageConfig: {
      type: Object,
      default: () => {},
    },
    isLock: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading:false,
      showRule:false,
      openAll:false,
      totalSignInCount:4,//累计签到数量
      prizeResult:{},//中奖结果
      nextAwardDTO:null,
      signInList:[],
      showPrizeList:false,//中奖记录显示
      winRecordId:0
    };
  },
  computed: {
    ...mapState(["commonStore"]),
    signInShowList(){
      let list
      if(this.openAll){
        list = this.signInList
      }else{
        list = this.sliceArrayBySignInCount(this.signInList, this.totalSignInCount)
      }
      return list
    },
    platformRrize(){
      if(this.commonStore.device == "androidApp" || this.commonStore.device == "iosApp"){
        return 'APP';
      }else if(this.commonStore.device == "wechat"){
        return "WXAPP";
      }else{
        return "PC";
      }
    },
    platform() {
      return this.commonStore.platform;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    backgroundConfigDTO(){
      return this.componentConfig.backgroundConfigDTO
    },
    buttonColor(){
      return this.backgroundConfigDTO?.buttonColor||this.pageConfig.buttonColor
    },
    moduleIconUrl(){
      if(this.commonStore.isForPC){
        return this.backgroundConfigDTO?.moduleIconPcUrl||this.pageConfig.moduleIconPcUrl
      }else{
        return this.backgroundConfigDTO?.moduleIconUrl||this.pageConfig.moduleIconUrl
      }
    },
  },
  mounted() {
    console.log('签到',this.componentConfig);
    this.getSignInList()
  },
  methods: {
    showMyPrizeEvent(){//打开中奖记录弹窗
      if(!this.isLogin){
        this.$base.toLogin();
        return
      }
      this.showPrizeList = true;
    },
    sliceArrayBySignInCount(arr, totalSignInCount) {
      // 确定n的值，即totalSignInCount除以5后向下取整的倍数
      const n = Math.floor(totalSignInCount / 5) * 5;
      // 计算截取范围的起始索引和结束索引
      let startIndex = n;
      const endIndex = Math.min(n + 10, arr.length); // 确保不会超出数组长度
      console.log('99999999',totalSignInCount,arr.length,n,totalSignInCount>arr.length-5,startIndex)
      if(totalSignInCount>arr.length-5){
        startIndex = startIndex-5;
      }
      // 截取数组并返回结果
      return arr.slice(startIndex, endIndex);
    },
    awardInfo(item){
      if(item.awardDTO.prizeType==0){
        return;
      }
      this.$refs.prizePop.open({ variant: 'prizeInfo' },item);
    },
    afterCloseAction(){
      console.log(this.prizeResult,'afterCloseAction');
      // 虚拟奖品，去使用 跳转链接
      if(this.prizeResult.prizeType==2){
        let url;
        if(this.platformRrize == 'APP' && this.prizeResult.appReceivePrizeUrl){//区别平台类型：APP, WXAPP, H5(移动端的浏览器，微信等), PC
          url = this.prizeResult.appReceivePrizeUrl;
        }else if(this.commonStore.appType == 'weixin' && this.platform.indexOf('WX') == -1){//小程序
          let deeplinkid = this.$route.query.deeplinkid || localStorage.getItem("deeplinkid");
          let jumpUrl = this.prizeResult.miniProgramReceivePrizeUrl;
          let _jumpurl = this.getUrlBeforeQuestionMark(jumpUrl);
          let params = this.getUrlParams(jumpUrl);
          let query = "";
          if (_jumpurl == "pages/op/index") {
            query =
              `id=${params.id}` +
              (deeplinkid ? `&deeplinkid=${deeplinkid}` : "");
          } else {
            query = deeplinkid ? `&deeplinkid=${deeplinkid}` : "";
          }
          this.handleMiniLogin(_jumpurl, query);
        }else if(this.prizeResult.webReceivePrizeUrl){
          url = this.prizeResult.webReceivePrizeUrl;
        }
        if(url){
          window.location.href = url;
        }
      }
    },
     // 获取url问号之前的部分
    getUrlBeforeQuestionMark(url) {
      var index = url.indexOf("?");
      if (index !== -1) {
        return url.substring(0, index);
      } else {
        return url;
      }
    },
    getUrlParams(curl) {
      let url = curl;
      let params = {};
      let queryString = url.split("?")[1] || "";
      let keyValuePairs = queryString.split("&") || [];
      if (keyValuePairs.length > 0) {
        for (var i = 0; i < keyValuePairs.length; i++) {
          var keyValue = keyValuePairs[i].split("=");
          params[decodeURIComponent(keyValue[0])] = decodeURIComponent(
            keyValue[1]
          );
        }
      }
      return params;
    },
            // 小程序跳转
    handleMiniLogin(path, query) {
      const params = {
        from_domain: this.platform.includes("yjs")
          ? "yjs_wxapp"
          : "51job_weixin_wxapp",
        rand: this.generate6DigitUUID(9),
        guid: this.generate6DigitUUID(5),
        wx_biz: {
          path: path,
          query: query,
          expire_type: 1,
          expire_time: new Date().getTime() + 24 * 60 * 60 * 1000,
          expire_interval: 1,
          env_version:
            process.env.NODE_ENV === "production" ? "release" : "trial",
        },
      };
      console.log(
        this.platform,
        this.platform.includes("yjs"),
        params,
        "小程序跳转66--------------"
      );
      this.$api.activity.getWxUrl(params).then((res) => {
        console.log(res);
        const { url_link = {} } = res.resultbody || {};
        if (url_link.errcode == "0") {
          const link = url_link.url_link;
          window.location.href = link;
        } else {
          this.$toast("获取微信短链失败");
        }
      });
    },
    generate6DigitUUID(num) {
      return Math.floor(100000 + Math.random() * (9 * 10 ** num)).toString();
    },
    openRule() {
      this.showRule = true;
    },
    signInPop(item){
      if(item.awardDTO.prizeType==0){//空奖品
        this.$toast("签到成功");
        return;
      }
      let awardDTO = item.awardDTO
      // awardDTO.webUrl = 'https://www.baidu.com/'
      // 非空奖品-奖品弹窗
      // this.prizeResult = {
      //   // prizeType: 1,//实物
      //   prizeType: 2,//虚物
      //   // TODO接口缺少跳转链接
      //   appReceivePrizeUrl: awardDTO.appUrl,
      //   miniProgramReceivePrizeUrl:awardDTO.wechatUrl,
      //   webReceivePrizeUrl:awardDTO.webUrl,
      //   // appReceivePrizeUrl:'111',//去使用
      //   // appReceivePrizeUrl:'',//我知道了
      // } 
      this.prizeResult = {
        prizeType: awardDTO.prizeType,// # 奖品类型 1实物，2虚拟物品 0空奖品
        // prizeType: 2,
        appReceivePrizeUrl: awardDTO.appUrl,
        miniProgramReceivePrizeUrl:awardDTO.wechatUrl,
        webReceivePrizeUrl:awardDTO.webUrl,
      }
      this.$refs.prizePop.open({ variant: 'winPrize' },item);
      // this.$toast("签到成功");
    },
    async getSignInList() {
      const res = await this.$api.activity.getSignInList({
        componentId: this.componentConfig.id,
        activityId: this.componentConfig.activityId,
      });
      if (res?.code == "0" && res?.data) {
        this.signInList = res.data.awardSignInfoList
        this.nextAwardDTO = res.data.nextAwardDTO
        this.totalSignInCount = res.data.totalSignInCount
      } else {
        this.$toast(res.msg);
      }
    },
    // 签到接口
    async signInHandle(item) {
      if(!this.isLogin){
        this.$base.toLogin();
        return
      }
      const res = await this.$api.activity.signIn({
        componentId: this.componentConfig.id,
        activityId: this.componentConfig.activityId,
        prizeId: item.awardDTO.id,
        dayNum: item.signIndex
      });
      if (res?.code == "0" && res?.data) {
        this.signInPop(item)
        this.winRecordId = res.data.recordId
        this.getSignInList()
        // 中奖信息的id,在抽奖接口中返回
        console.log(this.winRecordId);
        console.log(res);
      } else {
        this.$toast(res.msg);
      }
    },
    // 中奖信息列表
    async getWinAwardList(callback) {//中奖记录
      if(!this.commonStore.accountId){
        return
      }
      const res = await this.$api.activity.getWinAwardList({
        componentId: this.componentConfig.id,
        activityId: this.componentConfig.activityId,
      });
      if (res?.code == "0" && res?.data) {
        callback(res.data);
      } else {
        callback(false);
      }
    },
    async submitWinInfo(tel,winRecordId,callback){//用户提交领奖信息
      try{
        let res = await this.$api.activity.updateWinAward({
          mobile:tel,
          winRecordId: this.winRecordId?this.winRecordId:winRecordId,
          // winRecordId: 1160,
          activityId: this.componentConfig.activityId, //活动id
        });
        if (res?.code == "0" && res?.data) {
          callback(res.data);
        }else{
          callback(false);
        }
      }catch(error){
        console.log("提交手机号失败");
        callback(false);
      }    
    },
  },
};
</script>

<style lang="less" scoped>
.signIn_wrap {
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px 12px 0px 0px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  padding-bottom: 24px;
  position: relative;
  .adapt_pc_widescreen & {
    width: 1200px;
    margin: 0 auto;
  }
  .header {
    // display: flex;
    // align-items: baseline;
    padding: 13px 16px 10px 16px;
    // font-weight: 600;
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    // .header_title {
    //   font-size: 20px;
    //   color: #ffffff;
    //   line-height: 30px;
    // }
    // .header_desc {
    //   font-size: 14px;
    //   font-weight: 500;
    //   color: #ffffff;
    //   text-shadow: 0px 2px 8px #e16e69;
    //   margin-left: 9px;
    // }
    .header_info {
      .header_title {
        width: 98px;
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        line-height: 30px;
        text-shadow: 0px 2px 8px #e16e69;
      }
      .header_desc {
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        text-shadow: 0px 2px 8px #e16e69;
        margin-left: 9px;
      }
    }
    .header_change {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 25px;
      .change_btn{
        width: 64px;
        height: 25px;
        border-radius: 13px;
        color: #ffffff;
        font-size: 12px;
        text-align: center;
      }
      .rule_btn{
        width: 48px;
        margin-left: 6px;
      }
      
    }
  }
  .content {
    background: #ffffff;
    border-radius: 8px;
    margin: 8px;
    margin-top: 0px;
    overflow: hidden;
    .empty {
      width: 100%;
      height: 64px;
      border-radius: 8px;
      box-sizing: border-box;
      position: relative;
      border: 1px solid #ffffff;
      cursor: pointer;
      background-image: url("./images/empty_company@3x.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .skeleton {
      width: 100%;
      height: 64px;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 24%,
        rgba(255, 255, 255, 0.9) 25%,
        rgba(255, 255, 255, 0.9) 75%,
        rgba(255, 255, 255, 0) 76%,
        rgba(255, 255, 255, 0) 100%
      );
      background-size: 50% 100%;
      filter: blur(25px);
      animation: gradient 1.5s linear infinite;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }

      100% {
        background-position: 100% 50%;
      }
    }
    .sign_wrap{
      padding: 12px 12px;
      .sign_tip{
        margin-left: 2px;
        font-weight: 400;
        font-size: 14px;
        color: #4C4F54;
        margin-bottom: 12px;
        span{
          font-weight: 600;
          color: #FF6C0E;
          font-size: 14px;
        }
      }
    }
    .sign_item{
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: space-between;
      // gap:5px;
    }
    .sign_box{
      width: 20%;
      padding: 0 2px 0 3px;
      display: inline-block;
      box-sizing: border-box;
      .box_wrap{
        height: 67px;
        padding: 4px 0;
        border-radius: 8px;
        opacity: 1;
        background: linear-gradient(180deg, #FFF5D7 0%, #FFFFFF 100%), #FFFFFF;
        box-sizing: border-box;
        border: 1px solid #FFEFC5;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 5px;
        position: relative;
      }
      .signed_box{
        opacity: 1;
        background: linear-gradient(180deg, #FFE375 0%, #FFF5A0 100%), #FFFFFF;
        box-sizing: border-box;
        border: 1px solid #FFE16B;
        .signed{
          font-size: 11px;
          font-weight: normal;
          line-height: 17px;
          text-align: center;
          letter-spacing: 0px;
          color: #CA7900;
          margin-top: 5px;
        }
      }
      .prize{
        position: relative;
        width: 37px;
        height: 37px;
        img{
          width: 37px;
          height: 37px;
        }
        .count{
          position: absolute;
          right: -7px;
          top: 0px;
          width: 17px;
          height: 12px;
          font-size: 9px;
          font-weight: normal;
          line-height: 12px;
          text-align: center;
          letter-spacing: 0px;
          font-variation-settings: "opsz" auto;
          color: #FFFFFF;
          border-radius: 12px;
          opacity: 1;
          background: linear-gradient(90deg, #FF5500 0%, #FF9634 100%), linear-gradient(90deg, #969696 0%, #B8B8B8 100%);
        }
        .without{
          width: 37px;
          height: 15px;
          border-radius: 2px;
          opacity: 1;
          background: rgba(0, 0, 0, 0.7);
          font-size: 10px;
          font-weight: normal;
          line-height: normal;
          text-align: center;
          letter-spacing: 0px;
          color: #DCDCDC;
          position: absolute;
          bottom: 0;
        }
      }
      
      .sign_btn{
        border-radius: 80px;
        opacity: 1;
        width: 47px;
        height: 19px;
        background: linear-gradient(180deg, #FFAA41 0%, #FF661E 100%);
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0px;
        color: #FFFFFF;
        margin-top: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .next_day{
        width: 100%;
        height: 23px;
        position: absolute;
        bottom: 0;
      }
      .days{
        margin-top: 5px;
        font-size: 11px;
        font-weight: normal;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0px;
        color: #3D3D3D;
      }
    }
    
    .all_btn{
      text-align: center;
      margin-top: 3px;
      font-size: 12px;
      font-weight: normal;
      line-height: 15px;
      text-align: center;
      letter-spacing: 0px;
      color: #4C4F54;
      display: flex;
      align-items: center;
      justify-content: center;
      .arrow{
        width: 8px;
        height: 8px;
        margin-left: 2px;
      }
      .close{
        transform: rotate(180deg);
      }
    }
  }
  .prize_box {
    border-radius: 10px;
    opacity: 1;
    background: rgba(0, 0, 0, 0.7);
    padding: 16px 20px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    text-align: center;
    display: none;
    z-index: 999;
    img {
      height: 27px;
    }
    .prize_name {
      font-size: 14px;
      font-weight: normal;
      color: #ffffff;
      margin-top: 8px;
    }
  }
  .rule_van-popup{
    background:none;
  }
  .rule_van-popup::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffff; /* 你想要的背景色 */
    z-index: -1; /* 确保伪元素在内容下面 */
  }
  .rule_wrap {
    margin-top: 30px;
    z-index: 0;
    position: relative;
  }
  .rule_close {
    height: 14px;
    width: 14px;
    position: absolute;
    top: -8px;
    right: 16px;
    z-index: 1;
  }
  .rule_content::before {
    content: '';
    background-image: url("./images/rule.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 175px;
    position: absolute;
    top: -22px;
    // bottom: 0;
    z-index: 1;
  }
  .rule_content {
    overflow-y: scroll;
    // max-height: 55vh;
    z-index: 1;
    position: relative;
    .text_bg{
      background:#ffffff;
      margin-top: 40px;
      padding: 10px 16px 16px;
      min-height: 135px;
    }
    .rule_text {
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0px;
      color: #4c4f54;
      z-index: 1;
      position: relative;
      overflow-y: scroll;
      max-height: 60vh;
    }
  }
  .van-overlay{
    z-index: 999;
  }
  .van-popup{
    top: auto !important;
  }
  // .van-popup--bottom{
  //   width: 100% !important;
  //   .pc & {
  //     width: 375px !important;
  //   }
  // }
}
</style>
